import fetchIntercept from 'fetch-intercept'

export const unregister = fetchIntercept.register({
  request: function (url, config) {
    return [url, config]
  },

  requestError: function (error) {
    return Promise.reject(error)
  },
  response: async function (response) {

    const isMyBackend = response.url.startsWith(
      process.env.REACT_APP_API_URL
    )

    if (isMyBackend && response.status === 401) {
      window.location.href = '/auth/logOut'
      return response
    }
    return response
  },

  responseError: function (error) {
    return Promise.reject(error)
  },
})
